import * as React from "react";
import Paper from "@mui/material/Paper";
import { message as feedback } from "antd";
import moment from "moment";
import {
  DataGrid,
  GridToolbar,
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import {
  Button,
  Divider,
  TextField,
  Typography,
  Alert,
  Snackbar,
  Pagination,
  PaginationItem,
} from "@mui/material";
import API from "../../Api/api";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
function CustomPagination() {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <Pagination
      color='primary'
      sx={{ bgcolor: "#ffffff" }}
      variant='outlined'
      shape='rounded'
      page={page + 1}
      count={pageCount}
      // @ts-expect-error
      renderItem={(props2) => <PaginationItem {...props2} disableRipple />}
      onChange={(event, value) => apiRef.current.setPage(value - 1)}
    />
  );
}

const columns = [
  { field: "code", headerName: "Asset Code", minWidth: 170 },
  {
    field: "description",
    headerName: "Description",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    field: "location",
    headerName: "Location",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    field: "sub_location",
    headerName: "Sub-Location",
    minWidth: 170,
    align: "center",
  },
  {
    field: "category",
    headerName: "Category",
    minWidth: 170,
    align: "center",
  },
  {
    field: "purchase_date",
    headerName: "Purchase Date",
    minWidth: 170,
    align: "center",
  },
  {
    field: "exhaustion_date",
    headerName: "Exhaustion Date",
    minWidth: 170,
    align: "center",
  },
  {
    field: "cost",
    headerName: "Cost",
    minWidth: 170,
    align: "center",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(
  id,
  code,
  description,
  category,
  location,
  sub_location,
  purchase_date,
  exhaustion_date,
  cost
) {
  return {
    id,
    code,
    description,
    category,
    location,
    sub_location,
    purchase_date,
    exhaustion_date,
    cost,
  };
}

export default function ExhaustedAssetReport() {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const [message, setMessage] = React.useState(false);

  const [data, setData] = React.useState([]);
  const [filterData, setFilterData] = React.useState({
    start_date: "",
    end_date: "",
  });
  const today = new Date();
  React.useEffect(() => {
    const fetchData = async () => {
      setMessage(true);
      const res = await API.get(
        `/api/v1/company-assets/ppe/ppe-section?approve=true&exhaustion_date[lt]=${today}`
      );
      if (res.data[0]) {
        setData(res.data);
        setMessage(false);
      } else {
        setData([]);
        setMessage(false);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const start = filterData.start_date
    ? `&exhaustion_date[gte]=${filterData.start_date}`
    : "";
  const end = filterData.end_date
    ? `&exhaustion_date[lte]=${filterData.end_date}`
    : "";
  const query = `/api/v1/company-assets/ppe/ppe-section?approved=true&${start}${end}`;
  // function to fetch the data from the database
  const fetchData = async () => {
    let fetchingId;
    try {
      if (!filterData.start_date && !filterData.end_date) {
        feedback.error("Please select a date");
        return;
      }
      if (filterData.start_date || filterData.end_date) {
        fetchingId = toast.loading("Loading exhausted assets...");
        const res = await API.get(query);
        toast.remove(fetchingId);
        if (res.data.length === 0) {
          feedback.info("No asset exhausted within the selected period");
          return;
        }

        if (res.data.length > 0) {
          setData(res.data);
          feedback.info("Exhausted assets successfully loaded");
        }
      }
    } catch (error) {
      toast.remove(fetchingId);
      toast.error(error.message);
    }
  };

  const rows = data.map((data) => {
    return createData(
      data._id,
      data.code,
      data.description,
      data.category,
      data.location,
      data.sub_location,
      moment(data.purchase_date).format("YYYY-MM-DD"),
      moment(data.exhaustion_date).format("YYYY-MM-DD"),
      data.cost
    );
  });
  return (
    <div style={{ height: "83vh" }}>
      <div
        style={{
          fontSize: "14px",

          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          columnGap: "10px",
          // alignItems: "center",
          // justifyContent: "space-between",
        }}>
        <Typography
          variant='body1'
          htmlFor='start-date'
          style={{ color: `${mode === "dark" ? "#0883FF" : "#116149"}` }}>
          Start Date
        </Typography>
        <TextField
          size='small'
          id='start-date'
          type='date'
          style={{ backgroundColor: "#ccc", borderRadius: "5px" }}
          value={filterData.start_date}
          onChange={(e) =>
            setFilterData({
              ...filterData,
              start_date: e.target.value,
            })
          }
        />
        <Typography
          variant='body1'
          htmlFor='end-date'
          style={{ color: `${mode === "dark" ? "#0883FF" : "#116149"}` }}>
          End Date
        </Typography>
        <TextField
          size='small'
          id='end-date'
          style={{ backgroundColor: "#ccc", borderRadius: "5px" }}
          type='date'
          value={filterData.end_date}
          onChange={(e) =>
            setFilterData({
              ...filterData,
              end_date: e.target.value,
            })
          }
        />
        <Button
          onClick={fetchData}
          style={{
            marginLeft: "10px",
            textTransform: "none",
            backgroundColor: `${mode === "dark" ? "#0883FF" : "#116149"}`,
          }}
          variant='contained'>
          Generate Report
        </Button>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={message}
        autoHideDuration={6000}>
        <Alert severity='info'>
          Loading <span className='blinking-text'>.....</span>
        </Alert>
      </Snackbar>
      <Divider style={{ marginBottom: "10px" }} />
      <Paper sx={{ width: "100%", height: "70vh" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          style={{
            backgroundColor: `${mode === "dark" ? "#101418" : "#ffffff"}`,
            color: `${mode === "dark" ? "#fff" : "#000"}`,
          }}
          sx={{
            boxShadow: 2,
            border: 1,
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
            "& .MuiDataGrid-footerCell": {
              backgroundColor: "primary.main",
            },
            "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
              backgroundColor: mode === "light" ? "#fafafa" : "#1d1d1d",
              borderBottom: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
              borderRight: `1px solid ${
                mode === "light" ? "#f0f0f0" : "#303030"
              }`,
            },
            "& .MuiDataGrid-cell": {
              color:
                mode === "light" ? "rgba(0,0,0,.85)" : "rgba(255,255,255,0.65)",
            },
          }}
          slots={{ toolbar: GridToolbar, pagination: CustomPagination }}
        />
      </Paper>
    </div>
  );
}
